module.exports = __webpack_public_path__ + "img/鼓掌.b354c96e.gif";